import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=6e922fc5&"
import script from "./alipay.vue?vue&type=script&lang=js&"
export * from "./alipay.vue?vue&type=script&lang=js&"
import style0 from "./alipay.vue?vue&type=style&index=0&id=6e922fc5&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e922fc5')) {
      api.createRecord('6e922fc5', component.options)
    } else {
      api.reload('6e922fc5', component.options)
    }
    module.hot.accept("./alipay.vue?vue&type=template&id=6e922fc5&", function () {
      api.rerender('6e922fc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/alipay.vue"
export default component.exports